import { createStore } from "vuex";
import VueCookies from "vue-cookies";
import filters from "./filters/filters.js"

const store = createStore({
    modules: { filters },
    state() {
        return {
            showPricesWithTax:
                VueCookies.get("showPricesWithTax") === "true" || false,
            quantity: 1,
            comparedProducts: VueCookies.isKey("comparedProducts")
                ? VueCookies.get("comparedProducts")
                : [],
            isShowCompareModal: false,
            isShowProductModal: false,
            modalTimeoutId: null,
        };
    },

    actions: {
        async SET_COMPARED_PRODUCTS({ commit, state }, value) {
            const maxValues = 5;
            const timeout = 1000 * 7 //modal dissapearance timeout 7s
            let values = VueCookies.get("comparedProducts") || [];

            if (
                !values.find((el) => el === value) &&
                values.length < maxValues
            ) {
                //take existing list and update it with new product
                //set modal to dissapear after set timeout
                let newProductList = [...state.comparedProducts];

                newProductList.push(value);

                commit("SET_COMPARED_PRODUCTS", newProductList);

                if (state.modalTimeoutId) {
                    clearTimeout(state.modalTimeoutId);
                    commit("setModalTimeoutId", null);
                }

                commit("SET_IS_SHOW_COMPARE_MODAL", true);

                const newModalTimeoutId = setTimeout(() => {
                    commit("SET_IS_SHOW_COMPARE_MODAL", false);
                    commit("setModalTimeoutId", null);
                }, timeout);

                commit("setModalTimeoutId", newModalTimeoutId);

                VueCookies.set(
                    "comparedProducts",
                    JSON.stringify(state.comparedProducts)
                );
            }

            if (values.length >= maxValues) {
                window.toastr.error(
                    window.in18["shop-compare"]["system_add_to_compare_max"]
                );
            }
        },
    },
    mutations: {
        setModalTimeoutId(state, id) {
            state.modalTimeoutId = id;
        },
        SET_SHOW_PRICES_WITH_TAX(state, value) {
            state.showPricesWithTax = value;
            VueCookies.set("showPricesWithTax", value, "30d");
        },
        SET_QUANTITY(state, value) {
            state.quantity = value;
        },

        SET_COMPARED_PRODUCTS: (state, products) =>
            (state.comparedProducts = products),

        REMOVE_COMPARED_PRODUCTS(state, value) {
            let values = VueCookies.get("comparedProducts") || [];

            state.comparedProducts = values.filter((el) => el !== value);
            VueCookies.set(
                "comparedProducts",
                JSON.stringify(state.comparedProducts)
            );

            window.toastr.success(
                window.in18["shop-compare"]["system_remove_to_compare_success"]
            );
        },
        SET_IS_SHOW_COMPARE_MODAL(state, value) {
            state.isShowCompareModal = value;
        },
        SET_IS_SHOW_PRODUCT_MODAL(state, value) {
            state.isShowProductModal = value;
        },
    },
    getters: {
        showPricesWithTax: (state) => state.showPricesWithTax,
        quantity: (state) => state.quantity,
        comparedProducts: (state) => state.comparedProducts,
        isShowCompareModal: (state) => state.isShowCompareModal,
        isShowProductModal: (state) => state.isShowProductModal,
    },
});

export default store;
